// @flow

import nightlyRates2020 from './2020'

export default nightlyRates2020
